import { Stack } from '@findy-code/yuffie/ui/stack';
import type { CSSProperties, ReactNode } from 'react';

import styles from './legacy-modal-body.component.module.scss';

type Props = {
  children?: ReactNode | undefined;
  className?: string;
  style?: CSSProperties;
  isVerticalCentering?: boolean;
};

/**
 * @deprecated Use `@findy-code/yuffie/ui` instead.
 */
export const LegacyModalBody = ({
  children,
  className,
  style,
  isVerticalCentering,
}: Props) => {
  return (
    <div
      className={[styles.modalBody, className].filter(Boolean).join(' ')}
      style={style}
    >
      <Stack
        className={`${styles.bodyLayout} ${
          isVerticalCentering ? 'isVerticalCentering' : ''
        }`}
        justify={isVerticalCentering ? 'center' : 'start'}
        spacing={0}
      >
        {children}
      </Stack>
    </div>
  );
};
